// extracted by mini-css-extract-plugin
export default {"sponsoredBanner":"K5-z","sponsoredTooltipWrapper":"L5-z","sponsoredTooltip":"M5-z","newCard":"N5-z"};